import { useContext } from 'react';
import { ConfigContext } from './config-context';
export var useConfig = function () { return useContext(ConfigContext); };
